import React from "react";
import ReactDom from "react-dom";
import Search from "./Search";

const container = document.getElementById("search-app");

$(document).on("click", ".js-search-open", () => {
    if (window.setSearchIsOpenState) {
        window.setSearchIsOpenState(true);
    }
});

if (container) {
    ReactDom.render(
        <Search popularTags={window.searchPopularTags} />,
        container
    );
}
